const ko = {
  placeholderText: "입력해 주세요",
  closeContentText: "현재 대화를 종료하시겠습니까?",
  cancelText: "​취소",
  okText: "확인",
  loadingAnswerQuestions:
    "이전 질문 답변 중입니다. 전송 전 잠시 기다려 주십시오.",
  networkAnomalyText: "네트워크 오류 발생. 잠시 후 다시 시도해 주세요.",
  errorText: "​​서버 오류",
  messageTooShort: "최소한 두 글자를 입력해야 합니다.",
  messageTooLong: "200글자를 초과할 수 없습니다.",
  systemErrorText:
    "​​시스템 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.​​​​",
  fileSizeExceeded: "개별 파일 크기는 {maxSize}MB를 초과할 수 없습니다.",
  abnormalDisconnectionText:
    "연결이 비정상 종료됐습니다. 다시 연결 중입니다...",
  evaluationText: "여러분의 평가가 우리를 더 좋게 만듭니다",
  emailLabel: "이메일 주소​",
  emailPlaceholder: "이메일 주소를 입력해 주세요",
  emailErrorText: "이메일 형식이 잘못되었습니다.",
  productLabel: "제품",
  productPlaceholder: "제품을 선택해 주세요",
  problemLabel: "문의 내용",
  problemPlaceholder: "문의하실 내용을 자세히 적어 주세요",
  submitText: "제출하기",
  submitField: "제출에 실패했습니다. 잠시 후 다시 시도해 주세요.",
  thankText:
    "협조해 주셔서 감사합니다! 최대한 빨리 연락드리겠습니다! 이메일을 확인하시거나 {link}하여 답변을 확인해 주세요!",
  clickHere: "여기를 클릭",
  thankEvaluation: "평가해 주셔서 감사합니다!",
  codeLabel: "인증번호 或 인증코드",
  codePlaceholder: "인증번호를 입력해 주세요",
  submittedSuccessfully: "제출 성공",
  supportContact: "지원 연락처",
  stillCancel: "그래도 취소​",
  useDiscount: "할인 적용하기",
  pauseDuration: "일시 정지 기간",
  uploadAttachment: "첨부 파일 업로드",
};
export default ko;
